import { Icon, LinkButton, Typography } from "@bca/ui-library";
import { LinkButtonProps } from "@bca/ui-library/dist/Button/button.type";
import React from "react";

export interface SaveThisSearchButtonProps extends Omit<LinkButtonProps, 'px'|'variant'|'width'> {}

const SaveThisSearchButton: React.FunctionComponent<SaveThisSearchButtonProps> = (props) => (
  <LinkButton variant="tertiary" px={0} width="auto" {...props}>
    <Icon
      width="16px"
      name="heart"
      weight="regular"
      color="primary-light-blue"
      mr={2}
      mb="2px"
      css={`
        flex-shrink: 0;
      `}
    ></Icon>
    <Typography
      color="primary-light-blue"
      variant="body"
      my="0"
      css={`
        text-decoration: underline;
      `}
    >
      Save this Search
    </Typography>
  </LinkButton>
);

export default SaveThisSearchButton;
